import { Search, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const filieres = [
  'Informatique',
  'Électricité & Énergies Renouvelables',
  'Génie Réseaux & Télécommunications',
  'Mécatronique',
  'Arts Numériques',
  'Agroforesterie',
  'Sciences du Bois & de la Forêt',
  'Exploration, Production & Transformation Minières',
  'Mines & Industries',
];

export default function ProgramSearchBlock() {
  const { t } = useTranslation();

  return (
    <section className="bg-navy py-10 px-6 lg:px-12 shadow-xl animate-in fade-in zoom-in-95 duration-700">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-end">
          <div className="md:col-span-2 flex flex-col gap-2 group">
            <label className="text-white text-xs font-bold uppercase tracking-[0.2em] opacity-80 group-focus-within:opacity-100 transition-opacity">
              {t('label_search_keyword', 'Rechercher par mot-clé')}
            </label>
            <div className="relative">
              <input
                type="text"
                className="w-full bg-white p-4 pr-12 outline-none text-navy font-bold placeholder:font-medium transition-shadow focus:ring-4 focus:ring-gold/20"
                placeholder={t('placeholder_studying', 'Ex: Informatique, Télécoms...')}
              />
              <Search className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 w-6 h-6" />
            </div>
          </div>

          <div className="flex flex-col gap-2 group">
            <label className="text-white text-xs font-bold uppercase tracking-[0.2em] opacity-80 group-focus-within:opacity-100 transition-opacity">
              {t('label_area_interest', "Domaine d'intérêt")}
            </label>
            <div className="relative">
              <select className="w-full bg-white p-4 pr-10 outline-none appearance-none text-navy font-bold cursor-pointer transition-shadow focus:ring-4 focus:ring-gold/20">
                <option value="">{t('domain_all_areas', 'Tous les domaines')}</option>
                {filieres.map((f) => (
                  <option key={f} value={f}>{f}</option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-navy w-5 h-5 pointer-events-none" />
            </div>
          </div>

          <div className="flex flex-col gap-2 group">
            <label className="text-white text-xs font-bold uppercase tracking-[0.2em] opacity-80 group-focus-within:opacity-100 transition-opacity">
              {t('label_credential_level', 'Niveau')}
            </label>
            <div className="relative">
              <select className="w-full bg-white p-4 pr-10 outline-none appearance-none text-navy font-bold cursor-pointer transition-shadow focus:ring-4 focus:ring-gold/20">
                <option>{t('level_all', 'Tous les niveaux')}</option>
                <option>Bachelor (Licence)</option>
                <option>Master Professionnel</option>
                <option>Doctorat (Co-tutelle)</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-navy w-5 h-5 pointer-events-none" />
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <button className="bg-gold text-navy px-12 py-4 font-black uppercase tracking-widest hover:brightness-110 transition-all text-lg shadow-lg active:scale-95">
            {t('btn_search_programs', 'Rechercher')}
          </button>
        </div>
      </div>
    </section>
  );
}
